import React from 'react'
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';

const Logs = ({ recoveryComLogs,loaderState }) => (
    <div className="container-fluid">
        {!loaderState ?
            <div className="row">

                <div className="col-xs-12 phocket-table-new">
                    {recoveryComLogs  ?
                        <table className="text-center ">
                            <thead>
                                <tr>
                                    <th className='text-center'>Sr. No.</th>
                                    <th className='text-center'>Comment</th>
                                    <th className='text-center'>Remark</th>
                                    <th className='text-center'>Comment By</th>
                                    <th className='text-center'>Added At</th>

                                </tr>
                            </thead>
                            <tbody>
                                {recoveryComLogs && recoveryComLogs?.length > 0 ? recoveryComLogs?.map((recData, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{recData.comment || "-"}</td>
                                            <td>{recData?.remark || "-"}</td>
                                            <td>{recData.commentBy || "-"}</td>
                                            <td>{recData.addedAt || "-"}</td>
                                        </tr>
                                    )
                                }):""}
                            </tbody>
                        </table>
                        : ""}
                </div>
            </div> :
            <div className='phocket-table-new' style={{ marginTop: '80px' }}>
                <table className='text-center '  >
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Type</th>
                            <th>Application Id</th>
                            <th>Subject</th>
                            <th>Body</th>
                            <th>Date</th>
                            <th>Send By</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                              <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>


                        </tr>
                        <tr>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                              <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>

                        </tr>
                        <tr>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                              <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>

                        </tr>
                        <tr>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                              <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>

                        </tr>
                        <tr>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                              <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>

                        </tr>
                        <tr>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                              <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>
                            <td><Skeleton height={40} /></td>

                        </tr>

                    </tbody>
                </table>
            </div>
        }
    </div>
)

export default Logs;